import React from 'react';
import CustomLink from '../CustomLink/CustomLink';
import './Header.css';

const Header = () => {
        const scrollTop = () => {
                window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                });
        }
        return (
                <nav className="navbar navbar-expand-lg navbar-dark mb-5 fixed-top">
                        <div className="container">
                                <h2 className="text-white p-3 brand-name"><span className="brand-color text-decoration-underline">MacBook</span> Analysis</h2>
                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                        <ul className="navbar-nav ms-auto text-center mb-2 mb-lg-0">
                                                <li className="nav-item pt-2 pb-2">
                                                        <CustomLink onClick={scrollTop} to="/">Home</CustomLink>
                                                </li>
                                                <li className="nav-item pt-2 pb-2">
                                                        <CustomLink onClick={scrollTop} to="/reviews">Reviews</CustomLink>
                                                </li>
                                                <li className="nav-item pt-2 pb-2">
                                                        <CustomLink onClick={scrollTop} to="/dashboard">Dashboard</CustomLink>
                                                </li>
                                                <li className="nav-item pt-2 pb-2">
                                                        <CustomLink onClick={scrollTop} to="/blogs">Blogs</CustomLink>
                                                </li>
                                                <li className="nav-item pt-2 pb-2">
                                                        <CustomLink onClick={scrollTop} to="/about">About</CustomLink>
                                                </li>
                                        </ul>
                                </div>
                        </div>
                </nav>
        );
};

export default Header;